import { render, staticRenderFns } from "./BuySubscriptionDialog.vue?vue&type=template&id=495fe674"
import script from "./BuySubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./BuySubscriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports